import {z} from 'zod';

export const LanguageFormSchema = z.object({
  language: z.string().min(1),
});

export type LanguageFormSchemaType = z.infer<typeof LanguageFormSchema>;
